<script setup lang="ts">
  defineProps<{
    modelValue: string;
    testid: string;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: string];
  }>();
</script>

<template>
  <div class="flex flex-col gap-1.5 px-6 py-8">
    <span class="text-sm font-semibold text-gray-07">Observações:</span>
    <textarea
      :value="modelValue"
      rows="4"
      :data-testid="testid"
      placeholder="Descreva qualquer observação sobre o treinamento"
      class="w-full resize-none rounded-lg border border-gray-02 p-4 text-sm text-gray-07 shadow-xs placeholder:text-gray-03 focus:border-gray-07 focus:outline-none"
      @input="emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    />
  </div>
</template>
